import { SVGProps } from 'react';

export const ScrollBarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='40'
    height='8'
    viewBox='0 0 40 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <rect x='2.5' y='2.5' width='16' height='3' rx='1.5' fill='#E7EDF7' />
    <rect x='2.5' y='2.5' width='16' height='3' rx='1.5' stroke='#E8EFFB' />
    <rect x='0.5' y='0.5' width='39' height='7' rx='3.5' stroke='#E8EFFB' />
  </svg>
);
